// Typings for Classic and Universal analytics: npm install --save-dev @types/google.analytics
// Typings for GA4: npm install --save-dev @types/gtag.js

//declare let gtag: Function | undefined;

import ControlParams = Gtag.ControlParams;
import EventParams = Gtag.EventParams;
import CustomParams = Gtag.CustomParams;
import EventNames = Gtag.EventNames;

/**
 * Sends Google Analytics Custom Event for GA4
 * @param eventName
 * @param eventParameters
 */
export const trackCustomEvent = (
    eventName: EventNames,
    eventParameters: ControlParams | EventParams | CustomParams,
): void => {
    if (typeof gtag === 'function') {
        // Google Analytics needs to be loaded
        gtag('event', eventName, eventParameters);
    }
    //TODO: extend by support of old formats (Classic and Universal)?
};
